import { reactive } from 'vue';

/**
 * TOASTS — the game's action feedback rail. Any code can call
 * `toast('Equipped Snub Revolver', { kind: 'success', icon })` and the
 * ToastHost (mounted once in HeroScreen) slides it in bottom-center,
 * deco-plaque styled, auto-dismissing after a beat.
 */

export type ToastKind = 'success' | 'error' | 'info';

export interface Toast {
  id: number;
  message: string;
  kind: ToastKind;
  /** Optional leading image (item art, currency icon…). */
  icon?: string;
  /** Optional accent (e.g. rarity hex) — overrides the kind's rail colour. */
  accent?: string;
}

const MAX_VISIBLE = 4;
const TTL_MS = 3600;

export const toasts = reactive<Toast[]>([]);
let seq = 0;

export function toast(
  message: string,
  opts: { kind?: ToastKind; icon?: string; accent?: string } = {},
): void {
  const id = ++seq;
  toasts.push({ id, message, kind: opts.kind ?? 'success', icon: opts.icon, accent: opts.accent });
  while (toasts.length > MAX_VISIBLE) toasts.shift();
  window.setTimeout(() => dismiss(id), TTL_MS);
}

export function dismiss(id: number): void {
  const i = toasts.findIndex((t) => t.id === id);
  if (i >= 0) toasts.splice(i, 1);
}
